"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deletePreviousBlock = exports.singleLineBreak = exports.newParagraphBelow = void 0;
var slate_1 = require("slate");
var LineBreak_1 = require("ContentTokens/DataModels/LineBreak");
var Utils_1 = require("../Utils");
var EditorWidgetRegistry_1 = require("../WidgetRegistry/EditorWidgetRegistry");
var newParagraphBelow = function (editor) {
    slate_1.Transforms.splitNodes(editor, { always: true });
    slate_1.Transforms.setNodes(editor, (0, EditorWidgetRegistry_1.createParagraphNode)());
};
exports.newParagraphBelow = newParagraphBelow;
var singleLineBreak = function (editor) {
    if (!editor.selection) {
        return;
    }
    slate_1.Transforms.insertNodes(editor, LineBreak_1.lineBreak.createSlateJson());
    var textEntry = (0, Utils_1.getNext)(editor, editor.selection.anchor.path, slate_1.Text.isText);
    if (!!textEntry) {
        slate_1.Transforms.select(editor, { path: textEntry[1], offset: 0 });
    }
};
exports.singleLineBreak = singleLineBreak;
var deletePreviousBlock = function (editor) {
    if (!editor.selection) {
        return;
    }
    var previousBlockEntry = (0, Utils_1.getPrevious)(editor, slate_1.Range.start(editor.selection).path, Utils_1.isBlockElement);
    if (previousBlockEntry) {
        slate_1.Transforms.removeNodes(editor, { at: previousBlockEntry[1] });
    }
};
exports.deletePreviousBlock = deletePreviousBlock;
